"use client";

import { useEffect } from "react";
import { addVisitedCategory } from "@/lib/visitedCategories";

/**
 * Invisible client component — records the product's category handle
 * into localStorage as soon as the product detail page mounts.
 *
 * @param {{ category: Array<{handle?: string, title?: string}> | {handle?: string, title?: string} }} props
 */
export default function CategoryTracker({ category }) {
  useEffect(() => {
    const cat = Array.isArray(category) ? category[0] : category;
    const handle = cat?.handle || cat?.title;
    if (handle) addVisitedCategory(handle);
  }, [category]);

  return null;
}
